const states = {
    LOCAL: 1,
    DEV: 2,
    PRODUCTION: 3,
}
export const getMode = (MODE = "PRODUCTION") => {
    const upperCaseMode = MODE.toUpperCase()
    return states.hasOwnProperty(upperCaseMode) ? 
        states[upperCaseMode] : new Error("Variable MODE must be 'PRODUCTION', 'DEV' OR 'LOCAL'")
}